<template>
  <v-list-item :disabled="conflict" @click="$emit('add')">
    <v-list-item-avatar v-if="course.seats_remaining === 0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon color="warning" v-on="on">fas fa-stop-circle</v-icon>
        </template>
        <span>Class is full.<br/>If you add this course you will be placed on the wait list.</span>
      </v-tooltip>
    </v-list-item-avatar>
    <v-list-item-avatar v-else-if="course.seats_remaining <= 5">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon color="info" v-on="on">fas fa-exclamation-circle</v-icon>
        </template>
        <span>Class is almost full; only {{ course.seats_remaining }} seats left.<br/>You may be placed on the wait list if you add this course.</span>
      </v-tooltip>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title style="white-space:normal">{{ course.main_label }}</v-list-item-title>
      <v-list-item-subtitle>Meets: {{ course.time_label }}</v-list-item-subtitle>
      <v-list-item-subtitle v-if="selected">This is already on your schedule</v-list-item-subtitle>
      <v-list-item-subtitle v-else-if="courseSelected">Another section of this course is on your schedule.</v-list-item-subtitle>
      <v-list-item-subtitle v-else-if="conflict">Conflicts with a course already on your schedule.</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
import { computed } from '@vue/composition-api'
import { hasOverlap } from './functions'
export default {
  props: {
    course: {
      type: Object,
      required: true
    },
    schedule: {
      type: Array,
      default: () => { return [] }
    }
  },
  setup (props) {
    const conflict = computed(() => {
      for (let i = 0; i < props.schedule.length; i++) {
        if (hasOverlap(props.schedule[i], props.course)) return true
      }
      return false
    })
    const selected = computed(() => {
      for (let i = 0; i < props.schedule.length; i++) {
        if (props.schedule[i].value === props.course.value) return true
      }
      return false
    })
    const courseSelected = computed(() => {
      for (let i = 0; i < props.schedule.length; i++) {
        if (props.schedule[i].course_num === props.course.course_num) return true
      }
      return false
    })

    return {
      conflict,
      selected,
      courseSelected
    }
  }
}
</script>
